<div [formGroup]="form"
     [kalLoading]="loading">

    <ng-container formArrayName="notificationCategoryList"
                  *ngFor="let category of notificationCategoryListFormArray.controls; index as categoryIndex; last as isLast">

        <kal-form-field [formGroupName]="categoryIndex"
                        class="without-label">

            <kal-checkbox formControlName="IsCategorieChecked"
                          [label]="category.get('LibelleCategorie').value"
                          kalTheme="switch">
            </kal-checkbox>

            <div class="notifications"
                 *ngIf="!!getCategoryFromIndex(categoryIndex)?.IsCategorieChecked">

                <p class="gup-U-margin-top--normal gup-U-margin-bottom--normal">
                    Afficher les notifications sur la page d'accueil :
                </p>

                <ng-container formArrayName="notificationList"
                              *ngFor="let notification of category.get('notificationList').controls; index as notificationIndex">

                    <kal-form-field [formGroupName]="notificationIndex"
                                    class="without-label">

                        <kal-checkbox formControlName="IsChecked"
                                      [label]="notification.get('Libelle').value"
                                      kalTheme="switch">
                        </kal-checkbox>

                    </kal-form-field>

                </ng-container>

            </div>

        </kal-form-field>

        <div *ngIf="!isLast" class="gup-O-separationLine"></div>

    </ng-container>

</div>
